export const config = (key) => window.config[key] ?? null;
